var _g, _path, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareDiagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 141 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_843_1418)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.181,
    cy: 120.738,
    rx: 48.0708,
    ry: 11.2619,
    fill: "#FFEBE7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.8052 129.591C103.726 129.591 130.414 102.692 130.414 69.51C130.414 36.3279 103.726 9.42853 70.8052 9.42853C37.8844 9.42853 11.1968 36.3279 11.1968 69.51C11.1968 102.692 37.8844 129.591 70.8052 129.591Z",
    fill: "url(#paint0_linear_843_1418)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.363 17.2858H40.3405C38.1071 17.2858 35.9652 18.18 34.386 19.7718C32.8068 21.3635 31.9196 23.5224 31.9196 25.7735V94.7126H32.0225V118.921C32.0224 119.856 32.26 120.775 32.7126 121.591C33.1652 122.407 33.8177 123.093 34.6077 123.582C35.3978 124.071 36.2992 124.349 37.2258 124.387C38.1524 124.426 39.0733 124.224 39.9007 123.802L67.5867 109.656C68.341 109.274 69.1732 109.076 70.0171 109.076C70.8609 109.076 71.6931 109.274 72.4474 109.656L100.985 123.906C101.813 124.319 102.732 124.513 103.655 124.468C104.578 124.423 105.474 124.142 106.259 123.65C107.044 123.159 107.691 122.473 108.139 121.659C108.588 120.845 108.822 119.928 108.821 118.997L108.746 94.7126V25.7499C108.74 23.5094 107.855 21.3623 106.285 19.7767C104.714 18.1911 102.585 17.2957 100.363 17.2858V17.2858Z",
    fill: "url(#paint1_linear_843_1418)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138 39.613C138.002 41.4479 137.342 43.2207 136.143 44.6012C134.943 45.9816 133.287 46.8753 131.482 47.1156C131.152 47.158 130.82 47.1798 130.488 47.1808H105.513C104.971 47.1796 104.43 47.1347 103.896 47.0463C101.6 46.6471 99.532 45.406 98.0896 43.5621C96.6473 41.7181 95.9327 39.4016 96.0832 37.0584C96.2338 34.7152 97.239 32.511 98.9052 30.87C100.571 29.2289 102.781 28.2671 105.109 28.1697C106.315 25.5294 108.34 23.3562 110.879 21.9778C113.418 20.5993 116.333 20.0905 119.184 20.5279C122.035 20.9654 124.668 22.3255 126.685 24.403C128.702 26.4805 129.994 29.1628 130.366 32.0453H130.48C131.467 32.0437 132.444 32.2382 133.357 32.6178C134.269 32.9974 135.098 33.5546 135.797 34.2575C136.495 34.9604 137.049 35.7952 137.427 36.7142C137.805 37.6331 138 38.6182 138 39.613Z",
    fill: "url(#paint2_linear_843_1418)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0019 24.7909C11.0019 26.3041 11.5983 27.7553 12.6598 28.8253C13.7214 29.8952 15.1611 30.4963 16.6624 30.4963H35.4551C37.3067 30.4865 39.0813 29.7483 40.4009 28.439C41.7205 27.1298 42.4808 25.3529 42.5198 23.487C42.5588 21.6211 41.8735 19.8135 40.6097 18.4494C39.346 17.0853 37.6038 16.2724 35.7543 16.184C34.8421 14.2035 33.3171 12.5748 31.4084 11.5422C29.4997 10.5097 27.3102 10.129 25.1686 10.4574C23.027 10.7858 21.0488 11.8055 19.5311 13.3634C18.0134 14.9214 17.038 16.9335 16.7513 19.0978H16.6664C15.1666 19.0967 13.7276 19.6957 12.6655 20.7631C11.6035 21.8305 11.0051 23.2792 11.0019 24.7909V24.7909Z",
    fill: "url(#paint3_linear_843_1418)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_843_1418)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.8378,
    cy: 81.2844,
    rx: 27.0965,
    ry: 5.85247,
    fill: "#FF7C86",
    fillOpacity: 0.39
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5784 30.8001L79.2402 44.404C79.4379 44.8073 79.7297 45.1562 80.0907 45.4207C80.4517 45.6852 80.8711 45.8573 81.3127 45.9223L96.2036 48.0867C96.7079 48.1646 97.1807 48.3819 97.5696 48.7147C97.9585 49.0474 98.2481 49.4824 98.4062 49.9712C98.5643 50.4601 98.5847 50.9835 98.4651 51.4833C98.3455 51.9832 98.0906 52.4397 97.7287 52.8021L86.9687 63.3882C86.6487 63.702 86.4095 64.0898 86.2717 64.5179C86.1339 64.946 86.1018 65.4015 86.1781 65.8449L88.7231 80.7927C88.8103 81.3038 88.7539 81.8293 88.5602 82.3097C88.3664 82.7901 88.0431 83.2062 87.6268 83.5109C87.2105 83.8157 86.7179 83.9969 86.2048 84.034C85.6916 84.0711 85.1783 83.9627 84.7232 83.721L71.4041 76.6479C71.0087 76.4389 70.5688 76.3297 70.1223 76.3297C69.6758 76.3297 69.2359 76.4389 68.8404 76.6479L55.5214 83.721C55.0664 83.9614 54.5537 84.0688 54.0413 84.031C53.5289 83.9932 53.0372 83.8119 52.6217 83.5073C52.2061 83.2028 51.8834 82.7872 51.6898 82.3075C51.4962 81.8278 51.4395 81.3031 51.5262 80.7927L54.0665 65.8449C54.1428 65.4015 54.1106 64.946 53.9729 64.5179C53.8351 64.0898 53.5959 63.702 53.2758 63.3882L42.5158 52.8021C42.154 52.4397 41.8991 51.9832 41.7795 51.4833C41.6599 50.9835 41.6802 50.4601 41.8383 49.9712C41.9964 49.4824 42.2861 49.0474 42.675 48.7147C43.0638 48.3819 43.5367 48.1646 44.0409 48.0867L58.9319 45.9082C59.3735 45.8432 59.7928 45.6711 60.1538 45.4066C60.5148 45.1421 60.8067 44.7932 61.0043 44.3898L67.6662 30.7859C67.898 30.3297 68.2506 29.9471 68.6848 29.6803C69.1191 29.4136 69.6181 29.2732 70.1266 29.2747C70.6351 29.2761 71.1333 29.4194 71.566 29.6886C71.9988 29.9579 72.3492 30.3425 72.5784 30.8001Z",
    fill: "url(#paint4_linear_843_1418)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99995 97.737C5.99905 99.5642 6.65724 101.329 7.85188 102.704C9.04651 104.078 10.6961 104.968 12.4933 105.207C12.8202 105.253 13.1498 105.276 13.4798 105.276H38.3454C38.8872 105.275 39.4281 105.23 39.9627 105.142C42.2616 104.756 44.3364 103.523 45.7845 101.683C47.2326 99.8422 47.9508 97.5251 47.7997 95.181C47.6485 92.8369 46.6389 90.633 44.9667 88.9968C43.2945 87.3606 41.0788 86.4089 38.7497 86.3262C37.5469 83.6988 35.5296 81.5366 33.0016 80.1653C30.4736 78.794 27.5719 78.288 24.7337 78.7234C21.8956 79.1589 19.2747 80.5123 17.2661 82.5796C15.2574 84.647 13.9697 87.3164 13.5971 90.1855H13.4798C12.4965 90.1855 11.5229 90.3809 10.6146 90.7606C9.70631 91.1402 8.8812 91.6966 8.18646 92.398C7.49173 93.0994 6.94102 93.932 6.56584 94.8481C6.19065 95.7642 5.99835 96.7459 5.99995 97.737V97.737Z",
    fill: "url(#paint5_linear_843_1418)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.341 57.4058C118.028 56.1662 119.164 55.0491 120.385 55.3952L122.059 55.8692C123.281 56.2153 123.672 57.7646 122.764 58.6581L121.52 59.882C120.612 60.7755 119.085 60.3432 118.771 59.1037L118.341 57.4058Z",
    fill: "#FFBEBD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9877 57.4058C18.6741 56.1662 19.8097 55.0491 21.0316 55.3952L22.7051 55.8692C23.9268 56.2153 24.3186 57.7646 23.4103 58.6581L22.1662 59.882C21.2579 60.7755 19.7307 60.3432 19.4172 59.1037L18.9877 57.4058Z",
    fill: "#FFBEBD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3021 7.31122C51.7431 5.46968 54.363 5.46968 54.8041 7.31122V7.31122C54.9614 7.96808 55.474 8.48188 56.1303 8.64156V8.64156C57.9758 9.0906 57.9758 11.7182 56.1303 12.1672V12.1672C55.474 12.3269 54.9614 12.8407 54.8041 13.4976V13.4976C54.363 15.3391 51.7431 15.3391 51.3021 13.4976V13.4976C51.1448 12.8407 50.6321 12.3269 49.9758 12.1672V12.1672C48.1303 11.7182 48.1303 9.0906 49.9758 8.64156V8.64156C50.6321 8.48188 51.1448 7.96808 51.3021 7.31122V7.31122Z",
    fill: "#FFBEBD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6072 118.783C74.6072 119.783 73.8058 120.577 72.8379 120.577C71.87 120.577 71.0686 119.783 71.0686 118.783C71.0686 117.784 71.87 116.99 72.8379 116.99C73.8058 116.99 74.6072 117.784 74.6072 118.783Z",
    stroke: "#FFBEBD",
    strokeWidth: 2.48287
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.678 102.251C117.119 100.41 119.739 100.41 120.18 102.251V102.251C120.337 102.908 120.85 103.422 121.506 103.582V103.582C123.352 104.031 123.352 106.658 121.506 107.107V107.107C120.85 107.267 120.337 107.781 120.18 108.438V108.438C119.739 110.279 117.119 110.279 116.678 108.438V108.438C116.52 107.781 116.008 107.267 115.352 107.107V107.107C113.506 106.658 113.506 104.031 115.352 103.582V103.582C116.008 103.422 116.52 102.908 116.678 102.251V102.251Z",
    fill: "#FFBEBD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.209 84.1022C123.209 85.1019 122.407 85.8954 121.439 85.8954C120.472 85.8954 119.67 85.1019 119.67 84.1022C119.67 83.1026 120.472 82.3091 121.439 82.3091C122.407 82.3091 123.209 83.1026 123.209 84.1022Z",
    stroke: "#FC9999",
    strokeWidth: 2.48287
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_843_1418",
    x: 0.337173,
    y: 87.7032,
    width: 139.688,
    height: 66.0698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8865,
    result: "effect1_foregroundBlur_843_1418"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_843_1418",
    x: 25.0508,
    y: 54.7414,
    width: 95.5741,
    height: 53.0861,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.3453,
    result: "effect1_foregroundBlur_843_1418"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_843_1418",
    x1: 70.3457,
    y1: -10.1355,
    x2: 71.5862,
    y2: 200.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1E1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE1E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_843_1418",
    x1: 127.53,
    y1: 129.995,
    x2: 34.6841,
    y2: 47.2279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE7DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_843_1418",
    x1: 130.042,
    y1: 58.7415,
    x2: 108.927,
    y2: 20.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBEBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_843_1418",
    x1: 36.5399,
    y1: 39.1882,
    x2: 20.662,
    y2: 10.4528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBEBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_843_1418",
    x1: 46.2886,
    y1: 43.9678,
    x2: 148.28,
    y2: 83.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDEAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70369,
    stopColor: "#FF426F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_843_1418",
    x1: 39.8833,
    y1: 116.794,
    x2: 18.8588,
    y2: 78.6943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBEBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6F5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareDiagram);
export default __webpack_public_path__ + "static/media/share-diagram.45f6dd9e.svg";
export { ForwardRef as ReactComponent };